import { object, string, number, array, date } from 'yup';

export const signUpFields = object({
  companyName: string().required(),
  email: string().required(),
  password: string().required(),
});

export const loginFields = object({
  email: string().required(),
  password: string().required(),
});

export const formFields = object({
  inspectionDate: date().required(),
  productCategoryId: number()
    .min(1)
    .required(),
  inspectionPOReportGroups: array().of(
    object().shape({
      inspectionPOItems: array().of(
        object().shape({
          itemName: string().required(),
          itemNo: string().required(),
          poNo: string().required(),
          orderQty: number().required(),
        })
      ),
    })
  ),
  typeOfService: string().required(),
  generalInspectLevel: string()
    .test(
      'required field',
      'inspectionFactory.generalInspectLevel is a required field',
      (val) => val !== 'na'
    )
    .required(),
  criticalMajorLevel: number().required(),
  criticalMinorLevel: number().required(),
  criticalLevel: number().required(),
  inspectionFactory: object().shape(
    {
      nameChi: string().when('name', {
        is: (value) => value === undefined || value === null || value === '',
        then: string().required(),
        otherwise: string().notRequired(),
      }),
      name: string().when('nameChi', {
        is: (value) => value === undefined || value === null || value === '',
        then: string().required(),
        otherwise: string().notRequired(),
      }),
      addressChi: string().when('address', {
        is: (value) => value === undefined || value === null || value === '',
        then: string().required(),
        otherwise: string().notRequired(),
      }),
      address: string().when('addressChi', {
        is: (value) => value === undefined || value === null || value === '',
        then: string().required(),
        otherwise: string().notRequired(),
      }),
      country: string().required(),
      city: string().required(),
    },
    [['nameChi', 'name'], ['addressChi', 'address'], 'country', 'city']
  ),
});
